import { ExperimentWrapper } from '@/features/experiments/experiment-wrapper';
const PDPExperiment = () => {
  return <ExperimentWrapper experimentTitle='debug_pdp_experiment' fallback={null} versions={{
    with_element: (expTitle, version) => <span data-exp={`${expTitle}: ${version}`} className='invisible hidden' />,
    without_element: null
  }} data-sentry-element="ExperimentWrapper" data-sentry-component="PDPExperiment" data-sentry-source-file="pdp-experiment.tsx" />;
};
export default PDPExperiment;